import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useMobile } from "@/providers/mobileProvider";
import { DashboardDesktopLayout } from "@/layouts/_desktopLayout";
import { DashboardMobileLayout } from "@/layouts/_mobileLayout";
import { GlobalError } from "@/global-error";
import { NotFound } from "@/not-found";

export const Route = createFileRoute("/dashboard")({
  component: DashboardOutlet,
  notFoundComponent: NotFound,
  errorComponent: GlobalError,
});

function DashboardOutlet() {
  // Initialize with undefined to avoid hydration mismatch
  const [defaultOpen, setDefaultOpen] = useState<boolean | undefined>(undefined);
  const [open, setOpen] = useState<boolean>(false);
  const { isMobile } = useMobile();

  useEffect(() => {
    // Access localStorage only on the client side
    const sidebarState = localStorage.getItem("sidebar:state");
    const isOpen = sidebarState === "true";
    setDefaultOpen(isOpen);
    setOpen(isOpen);
  }, []);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    localStorage.setItem("sidebar:state", String(newOpen));
  };

  // Only render once we have the initial state
  if (defaultOpen === undefined) return null;

  if (isMobile) {
    return (
      <DashboardMobileLayout>
        <Outlet />
      </DashboardMobileLayout>
    );
  }

  return (
    <DashboardDesktopLayout
      sidebarState={{
        defaultOpen,
        open,
        onOpenChange: handleOpenChange,
      }}
    >
      <Outlet />
    </DashboardDesktopLayout>
  );
}
